<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between mb-2">
    <div class="text-2xl">Add Project</div>
    <button mat-icon-button matDialogClose><mat-icon svgIcon="mat_solid:close"></mat-icon></button>
  </div>
  <div [formGroup]="projectForm" class="flex flex-col gap-2">
    <mat-stepper [linear]="true" #stepper [orientation]="orientation">
      <mat-step [stepControl]="general">
        <ng-template matStepLabel>Create Project</ng-template>
        <div class="flex flex-col gap-2 pt-4" formGroupName="general">
          <mat-form-field class="flex-auto gt-xs:pr-3 fuse-mat-dense" [subscriptSizing]="'dynamic'">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" cdkFocusInitial>
            <ngx-colors class="mr-2" matPrefix ngx-colors-trigger formControlName="color" [formats]="['hex']" colorPickerControls="no-alpha" onclick="event.stopPropagation()"></ngx-colors>
            <mat-error>Name is required!</mat-error>
          </mat-form-field>
          <mat-form-field class="flex-auto gt-xs:pl-3 fuse-mat-dense" [subscriptSizing]="'dynamic'">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
          <!-- <div>
            <label for="colorInput" class="font-medium">Color</label>
            <div
              class="mt-1.5 h-10 box-content flex flex-col justify-center border rounded-md border-gray-300 dark:border-gray-500 px-4">
              <input [cpOutputFormat]="'hex'" id="colorInput" cpPosition="top" [(colorPicker)]="color" matInput
                formControlName="color" [style.background]="color" readonly />
            </div>
          </div> -->
          <div class="flex flex-col sm:flex-row gap-2 mt-2">
            <div class="order-3 sm:order-1 flex flex-col">
              <ng-container [ngTemplateOutlet]="closeTmpl"></ng-container>
            </div>
            <div class="flex gap-2 ml-auto order-2">
              <button mat-stroked-button color="primary" (click)="addProject()"
                [disabled]="(submitting$ | async) || general.invalid">
                <div class="flex gap-2 items-center">
                  <mat-spinner diameter="20" *ngIf="submitting$ | async"></mat-spinner>
                  <span>Create and close</span>
                </div>
              </button>
              <button mat-raised-button matStepperNext color="primary" [disabled]="submitting$ | async">Next</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Add members</ng-template>
        <div class="flex flex-col gap-2 pt-4">
          <tm-members-form (init)="initMembers()"></tm-members-form>
          <div class="flex flex-col mt-2">
            <div class="flex gap-2 ml-auto">
              <button mat-stroked-button matStepperPrevious color="primary">Back</button>
              <button mat-raised-button matStepperNext color="primary" [disabled]="submitting$ | async">Next</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Add teams</ng-template>
        <div class="flex flex-col gap-2 pt-4">
          <tm-autocomplete-select-teams></tm-autocomplete-select-teams>
          <div class="flex flex-col mt-2">
            <div class="flex gap-2 ml-auto">
              <button mat-stroked-button matStepperPrevious color="primary">Back</button>
              <button mat-raised-button color="primary" (click)="addProject()"
                [disabled]="(submitting$ | async) || general.invalid">
                <div class="flex gap-2 items-center">
                  <mat-spinner diameter="20" *ngIf="submitting$ | async"></mat-spinner>
                  <span>Create</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
    <!-- <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="General" [disabled]="submitting$ | async">
        <div class="flex flex-col">
          <div class="flex flex-col gap-4">
            <mat-form-field class="flex-auto gt-xs:pr-3 fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" cdkFocusInitial>
              <mat-error>Name is required!</mat-error>
            </mat-form-field>
            <mat-form-field class="flex-auto gt-xs:pl-3 fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
            <div>
              <label for="colorInput" class="font-medium text-secondary dark:text-white">Color</label>
              <div
                class="mt-1.5 h-10 box-content flex flex-col justify-center border rounded-md border-gray-300 dark:border-gray-500 px-4">
                <input [cpOutputFormat]="'hex'" id="colorInput" cpPosition="top" [(colorPicker)]="color" matInput
                  formControlName="color" [style.background]="projectForm.get('color').value" readonly />
              </div>
            </div>
          </div>
          <div class="flex justify-end mt-4">
            <div class="flex flex-col">
              <button class="ml-auto" *ngIf="typeForm === 'edit'" mat-flat-button [color]="'primary'"
                [disabled]="(nameInValid || (submitting$ | async))"
                (click)="saveProject()">
                <div class="flex items-center gap-2">
                  <mat-spinner *ngIf="submitting$ | async" diameter="20"></mat-spinner>
                  <span>Save</span>
                </div>
              </button>
              <button *ngIf="typeForm === 'add'" mat-raised-button color="primary"
                [disabled]="nameInValid || (submitting$ | async)" (click)="addProject()">
                <div class="flex items-center gap-2">
                  <mat-spinner *ngIf="submitting$ | async" diameter="20"></mat-spinner>
                  <span>Add project</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Members" *ngIf="users$ | async as users" [disabled]="submitting$ | async">
        <mat-form-field [subscriptSizing]="'dynamic'" class="fuse-mat-dense w-full">
          <mat-label>
            Select a Members
          </mat-label>
          <mat-select formControlName="users" multiple>
            <mat-option *ngFor="let user of users" [value]="user.id"
              [disabled]="isDisabledUser(user.id)">{{user.displayName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="flex justify-end mt-4">
          <div class="flex flex-col">
            <button class="ml-auto" *ngIf="typeForm === 'edit'" mat-flat-button [color]="'primary'"
              [disabled]="submitting$ | async" (click)="addMembers()">
              <div class="flex items-center gap-2">
                <mat-spinner *ngIf="submitting$ | async" diameter="20"></mat-spinner>
                <span>Save</span>
              </div>
            </button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Teams" *ngIf="teams$ | async as teams" [disabled]="submitting$ | async">
        <div class="flex flex-col">
          <span class="text-primary-500 cursor-pointer ml-auto" (click)="selectAll(teams)">Select All</span>
        </div>
        <mat-form-field [subscriptSizing]="'dynamic'" class="fuse-mat-dense w-full">
          <mat-label>
            Select a Teams
          </mat-label>
          <mat-select formControlName="teams" multiple>
            <mat-option *ngFor="let team of teams" [value]="team.id">{{team.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="flex justify-end mt-4">
          <div class="flex flex-col">
            <button class="ml-auto" *ngIf="typeForm === 'edit'" mat-flat-button [color]="'primary'"
              [disabled]="submitting$ | async" (click)="addMembers()">
              <div class="flex items-center gap-2">
                <mat-spinner *ngIf="submitting$ | async" diameter="20"></mat-spinner>
                <span>Save</span>
              </div>
            </button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group> -->
  </div>
</div>

<ng-template #closeTmpl>
  <button mat-stroked-button color="primary" matDialogClose>Cancel</button>
</ng-template>